import graphql from 'babel-plugin-relay/macro';

export const AUTH_FORGOT_PRACTITIONER_PASSWORD_MUTATION = graphql`
  mutation authForgotPractitionerPasswordMutation($input: UserForgotPasswordInput!) {
    forgotPractitionerPassword(input: $input)
  }
`;

export const AUTH_VALIDATE_FORGOT_USER_PASSWORD_QUERY = graphql`
  query authValidateForgotUserPasswordQuery($input: ValidateForgotUserPasswordInput!, $skip: Boolean!) {
    validateForgotUserPassword(input: $input) @skip(if: $skip)
  }
`;

export const AUTH_RESET_USER_PASSWORD_MUTATION = graphql`
  mutation authResetUserPasswordMutation($input: UserResetPasswordInput!) {
    resetUserPassword(input: $input) {
      accessToken
      user {
        email
      }
    }
  }
`;
